import http from "@/http-common";

class PermissionApprovalDataService {
  getPermissionInfo(data: any): Promise<any> {
    return http.api.post("/getPermissionInfo/", data);
  }
  permisApproveDeny(data: any): Promise<any> {
    return http.api.post("/permisApproveDeny/", data);
  }
}
export default new PermissionApprovalDataService();
